import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import Headline6 from '../Typography/Heading/Headline6';
import Body2 from '../Typography/Body/Body2';
import rose from '../Palettes/rose';
import grey from '../Palettes/grey';
import colors from '../Theme/colors';

interface FeatureCardProperties {
  icon: ReactNode;
  title: string;
  description: string;
  tag?: string;
  className?: string;
}

const Card = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.white};
  border: 1px solid ${grey[200]};
  border-radius: 8px;
  padding: 1.5rem;
  transition: border-color 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: ${grey[400]};
  }
`;

const IconBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background: ${rose[600]};
  color: ${colors.white};
  margin-bottom: 1rem;

  svg {
    width: 22px;
    height: 22px;
  }
`;

const Description = styled(Body2)`
  margin-top: 0.5rem;
  flex: 1 1 auto;
`;

const Tag = styled.div`
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${rose[600]};
  margin-top: 1.25rem;
`;

const FeatureCard = ({
  icon,
  title,
  description,
  tag,
  className,
}: FeatureCardProperties) => (
  <Card className={className}>
    <IconBadge>{icon}</IconBadge>
    <Headline6 tag="h3">{title}</Headline6>
    <Description>{description}</Description>
    {tag && <Tag>{tag}</Tag>}
  </Card>
);

export default FeatureCard;
